import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function MembersView({ onClose, open, prodd }) {
  const navigate = useNavigate();

  const items1 = [
    {
      key: "5",
      label: "Name",
      children: prodd?.pmName ?? "N/A",
    },
    {
      key: "1",
      label: "ID Number",
      children: prodd?.pmIdNumber ?? "N/A",
    }, 
    {
      key: "2",
      label: "Email",
      children: prodd?.pmEmail ?? "N/A",
    }, 
    {
      key: "4",
      label: "Phone",
      children: prodd?.pmPhone ?? "N/A",
    },
    {
      key: "3",
      label: "Role",
      children: prodd?.pmRole ?? "N/A",
    }, 
    {
      key: "6",
      label: "Created Date",
      children: (
        <div>
          {prodd?.createdDate
            ? moment(prodd?.createdDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
  ];
  
  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Member Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Member Details"
          column={2}
          colon={false}
          items={items1}
          layout="vertical"
        />
        
      </div>
    </Drawer>
  );
}

export default MembersView;
